import React, { useId } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import FormFieldLabel from './FormFieldLabel';

/**
 * Shared form text input — top label + theme-styled outlined control.
 * Pass `sx` for one-off field customizations (overrides theme).
 */
const FormField = React.forwardRef(function FormField(
  {
    size = 'small',
    fullWidth = true,
    label,
    required,
    hint,
    id: idProp,
    sx,
    slotProps,
    ...props
  },
  ref
) {
  const generatedId = useId();
  const inputId = idProp || generatedId;

  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto' }}>
      <FormFieldLabel label={label} required={required} hint={hint} htmlFor={inputId} />
      <TextField
        ref={ref}
        id={inputId}
        hiddenLabel
        size={size}
        fullWidth={fullWidth}
        variant="outlined"
        required={required}
        sx={sx}
        slotProps={{
          ...slotProps,
          formHelperText: {
            sx: { mx: 0, mt: 0.75 },
            ...slotProps?.formHelperText,
          },
        }}
        {...props}
      />
    </Box>
  );
});

FormField.displayName = 'FormField';

export default FormField;
